import * as React from "react";
import { Grid, Typography, createStyles, makeStyles } from "@material-ui/core";
import _ from "lodash";

import { CustomTheme } from "../../../../../types/customTheme";
import TextfieldCommon from "../../../../../components/textField/TextfieldCommon";
import TextFieldCustom from "../../../../../components/textField/TextFieldCustom";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    labelStyle: {
      fontSize: "17px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "15px",
      },
    },
  }),
);

export interface StepFiveProps {
  warningThreshold: any;
  setWarningThreshold: any;
  baseUnit: any;
}

/**
 * StepFive Component
 *
 * This component represents the fifth step of a wizard modal.
 * It prompts the user to choose their preferred warning threshold level.
 */
const StepFive: React.FunctionComponent<StepFiveProps> = ({
  warningThreshold,
  setWarningThreshold,
  baseUnit,
}) => {
  const classes = useStyles();
  return (
    <>
      <Typography variant="h6">
        Please choose your preferred warning threshold level
      </Typography>
      <Typography variant="body1">
        Set a warning threshold to highlight low stock levels during purchase
        orders.
      </Typography>
      <Grid container style={{ marginTop: "20px" }}>
        <Grid item xs={12}>
          <TextFieldCustom
            id="warningThreshold"
            name="warningThreshold"
            type="number"
            label={
              <Typography className={classes.labelStyle}>
                {`Warning Threshold in ${baseUnit}`}
              </Typography>
            }
            value={warningThreshold}
            disabled={false}
            onChange={(e: any) => setWarningThreshold(e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default StepFive;
